module.exports = __webpack_public_path__ + "static/img/200326.8d1eec6c.png";